import React, { FC, useEffect, useState } from "react";
import Dialog from "../../dialog";
import {
  Container,
  HeadWrapper,
  BodyModal,
  Icon,
  Divider,
  NetName
} from './styles'
import { icons } from "../../../icons";
import Typography from "../../typography";
import Button from "../../button";
import Select from "../../select";
import RadioButtonGroup from "../../radiobuttons";
import { useTranslation } from "react-i18next";
import * as yup from 'yup';
import { useFormik } from 'formik';
import Input from "../../input";
import { BodyDefault, HeadLine3 } from "../../typography/styled";
import Toggle from "../../toggle";
import { useRouterCustom } from "../../../context/routerContext";
import TopProgress from "../../TopBarProgress";
import { routerService, clientService } from "../../../api";
import { useAuth } from "../../../context/user.context";
import { useUi } from "../../../context/ui.context";


type ModalProps = {
  closeModalCancel:() => void;
  closeModal:(props:any) => void;
  loading?:any;
  dataToEdit?:any;
  viewModal?:boolean;
}

const CreateRouter:FC<ModalProps> = (props) => {
  const {
    closeModal,
    closeModalCancel,
    loading,
    viewModal,
    dataToEdit
  } = props
  const [t] = useTranslation()
  const {user} = useAuth()
  const {viewAlert} = useUi()
  const [internetAcc, setinternetAcc] = useState<boolean>(true)
  const [adminState, setAdminState] = useState<boolean>(true)
  const [regions, setRegions] = useState<any[]>([])
  const [subnets, setSubnets] = useState<any[]>([])
  const [selectedSubnets, setSelectedSubnets] = useState<any[]>([])
  const [loadingOptions, setLoadingOptions] = useState<boolean>(true)

  // Staff/Client project selection
  const [createInClientProject, setCreateInClientProject] = useState<boolean>(true)
  const [selectedClient, setSelectedClient] = useState<any>(null)
  const [clients, setClients] = useState<any[]>([])
  const [clientsLoading, setClientsLoading] = useState<boolean>(false)
  const [clientSearchString, setClientSearchString] = useState<string>('')

  const editChecked = (sub:any) => {
    const founded = selectedSubnets.find((item:any) => item.value === sub?.value)
    if(founded) {
      setSelectedSubnets((prev:any) => {
        return prev.filter((item:any) => item.value !== sub?.value)
      })
    } else {
      setSelectedSubnets((prev) => [...prev, sub])
    }
  } 
  const [initialValues, setInitialValues] = useState<any>({
    name:'',
    // address:'',
    region:regions[0]?.value,
  })
  
  const {
    routerOptions,
    interfaceOptions,
    routers,
    setRouters,
  } = useRouterCustom()
  const getOptions = async () => {
    setSelectedSubnets([])
    setLoadingOptions(true)
    let promises:any[] = []
    routers.forEach((item:any) => {
      let promise = routerService.getSingleRouter(item.id)
      promises.push(promise)
    })
    Promise.all(promises)
    .then((res) => {
      let interfaces:any[] = []
      const data = res.map((it:any) => it.data)
      // if(interfaces)
      interfaces = data.flatMap((obj) => {
        const externalFixedIps = obj.external_fixed_ips || [];
        const interfaceFixedIps = obj.interfaces.flatMap((interfaceObj:any) => interfaceObj.fixed_ips || []);
        return externalFixedIps.concat(interfaceFixedIps);
      }).map(ipObj => ipObj.subnet_id);
      //@ts-ignore
      const ocupado = [...new Set(interfaces)]
      setRegions(routerOptions.regions.map((reg:any) => {
        return {
          label:reg.id,
          value:reg.id
        }
      }))
      handleChange('region')(routerOptions.regions[0]?.id)
      setSubnets(interfaceOptions.map((sub:any) => {
        return {
          ...sub,
          ocupado:ocupado.find((item) => item === sub.id),
          add_label:(
            <div style={{display:'flex', alignItems:'center', gap:'4px'}}>
              {ocupado.find((item) => item === sub.id) ? 
                <NetName>
                  {sub.name}
                </NetName> 
              :
                <Typography variant='body'>
                  {sub.name}
                </Typography>
              }
              <NetName>
                {sub.network_name}
              </NetName>
            </div>
            ),
          label:sub.name,
          value:sub.id,
        }
      }))
      if(dataToEdit){
        let keks = interfaceOptions.map((sub:any) => {
          return {
            ...sub,
            ocupado:ocupado.find((item) => item === sub.id),
            add_label:(
              <div style={{display:'flex', alignItems:'center', gap:'4px'}}>
                {ocupado.find((item) => item === sub.id) ? 
                  <NetName>
                    {sub.name}
                  </NetName> 
                :
                  <Typography variant='body'>
                    {sub.name}
                  </Typography>
                }
                <NetName>
                  {sub.network_name}
                </NetName>
              </div>
              ),
            label:sub.name,
            value:sub.id,
          }
        })
        routerService.getSingleRouter(dataToEdit.id)
        .then((res) => {
          res.data.interfaces.forEach((pidor:any) => {
            let finded:any = keks.find((f:any) => f.id === pidor?.fixed_ips?.[0].subnet_id)
            if(finded){
              editChecked(finded)
            }
          })
          // keks.forEach((int:any) => {
          //   if(res.data.interfaces.find((ip:any) => ip?.fixed_ips?.[0].subnet_id === int.id)){
          //     editChecked(int)
          //   }
          // })
          setLoadingOptions(false)
        })
        .catch((err:any) => {
          console.log('err - ', err);
          setLoadingOptions(false)
        })
      } else {
        setLoadingOptions(false)

      }
    })
  }

  useEffect(() => {
    // if(viewModal){
      getOptions()
    // }
  },[dataToEdit])

  // Load clients when switching to client project mode
  useEffect(() => {
    if (createInClientProject && !dataToEdit?.id) {
      loadClients();
    }
  }, [createInClientProject, clientSearchString]);

  const loadClients = () => {
    setClientsLoading(true);
    clientService.getAll({
      page: 1,
      page_size: 100,
      search: clientSearchString,
      has_enabled_project: true
    })
    .then((res) => {
      const clientsData = res.data?.objects || [];
      const formattedClients = clientsData.map((client: any) => ({
        id: client.id,
        value: client.id,
        label: `${client.first_name} ${client.last_name} (${client.email})`,
        data: client
      }));
      setClients(formattedClients);
    })
    .catch((error) => {
      console.error("Failed to load clients", error);
    })
    .finally(() => {
      setClientsLoading(false);
    });
  };

  const handleDestinationChange = (value: boolean) => {
    setCreateInClientProject(value);
    if (!value) {
      // Reset client selection when switching to admin project
      setSelectedClient(null);
    }
  };
  const onSubmit = (values:any) => {
    // Validate client selection if creating in client project
    if (createInClientProject && !selectedClient && !dataToEdit?.id) {
      viewAlert({
        severity:'error',
        message:t('PLEASE_SELECT_CLIENT'),
      })
      return;
    }

    const data:any = {
      admin_state_up:adminState,
      description:'',
      external_network_id:internetAcc ? routerOptions?.external_networks?.find((net:any) => net.name === 'external_network')?.id : "",
      name:values.name,
      region:values.region || regions[0]?.value,
    }

    // Add client context for new routers
    if (!dataToEdit?.id) {
      if (createInClientProject) {
        // Creating in client's project
        data.client = selectedClient;
      } else {
        // Creating in admin project
        data.client = null;
      }
    }

    if(dataToEdit) {
      data.id = dataToEdit.id
    }
    closeModal({
      setErrors,
      data:data,
      subnets:selectedSubnets,
      handleClose:() => {
        resetForm()
        setSelectedSubnets([])
      }
    })
  }
  const regName = /^[a-zA-Z0-9\\!\"#$%&'()*+,\-./:;<=>?@\[\\\]\^_`{\|}~ ]+$/
  const {
    values,
    errors,
    touched,
    handleSubmit,
    setErrors,
    handleChange,
    resetForm,
    handleBlur,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string()
      .required(`${t("REQUIRED_FIELD")}`)
      .matches(regName,`${t("ONLY_ENGLISH_LETTERS")}`)
      .max(60, `${t("STRING_VALIDATE_MAX")} 60 ${t("CHARACTERS")}`),
      // address:yup.string().required(),
      region:yup.string(),
    }),
    initialValues: {
      ...initialValues,
    },
    onSubmit,
  });
  
  const formikProps = {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
  };
  useEffect(() => {
    if(dataToEdit?.id){
      setInitialValues({
        name:dataToEdit.name,
        region:dataToEdit.region,
      })
      setinternetAcc(dataToEdit.external_network_id ? true : false)
      setAdminState(dataToEdit.admin_state_up)
      // setSelectedSubnets()
    }
  },[dataToEdit])
  if(loadingOptions) return <TopProgress loading={loadingOptions}/>
  return(
    <Container>
      <HeadWrapper>
        <HeadLine3 style={{marginLeft:'10px', marginTop:'10px'}}>
          {dataToEdit?.id ? t("EDIT_ROUTER") : t("CREATE_NEW_ROUTER")}
        </HeadLine3>
        <Icon onClick={closeModalCancel} src={icons.CloseIcon}/>
      </HeadWrapper>
      <BodyModal>
        {/* Staff/Client Project Selection - only for new routers */}
        {!dataToEdit?.id && (
          <>
            <div style={{ marginBottom: '16px' }}>
              <Typography variant="h4" style={{ marginBottom: '12px' }}>
                {t("PROJECT_SELECTION")}
              </Typography>
              <RadioButtonGroup
                title=""
                buttons={[
                  {
                    id: 'admin',
                    title: t("CREATE_ROUTER_IN_ADMIN_PROJECT"),
                    value: 'admin'
                  },
                  {
                    id: 'client',
                    title: t("CREATE_ROUTER_IN_CLIENT_PROJECT"),
                    value: 'client'
                  }
                ]}
                selectedButton={createInClientProject ? 'client' : 'admin'}
                onChange={(value: string) => handleDestinationChange(value === 'client')}
              />
            </div>

            {createInClientProject && (
              <Select
                required
                toolTip={false}
                data={clients}
                selectedValue={selectedClient}
                onChange={(id: any) => setSelectedClient(id)}
                title={t("CLIENT")}
                placeholder={t("SELECT_CLIENT")}
                fieldName='client'
                hasSearch={true}
                onSearchChange={setClientSearchString}
                customStyles={{marginBottom:'16px'}}
              />
            )}
          </>
        )}

        <Input
          required
          title={t('NAME_ROUTER')}
          fieldName='name'
          placeholder={''}
          onBlur={handleBlur}
          {...formikProps}
        />
        {/* <Select
          toolTip={false}
          data={regions}
          selectedValue={values['region'] || regions[0]?.value}
          onChange={(e) => handleChange('region')(e)}
          title={t("PLACEMENT_REGION")}
          customStyles={{width:'360px'}}
        /> */}
        {dataToEdit?.id ? null :
          <Toggle
            title={t("INTERNET_ACCESS")}
            value={internetAcc}
            onChange={() => setinternetAcc(!internetAcc)}
          />
        }
        {dataToEdit?.id ? null :
          <Select
            toolTip={false}
            data={subnets}
            selectedValue={selectedSubnets}
            multipleOnChange={editChecked}
            multi
            onChange={(e) => {handleChange('subnets')(e)}}
            title={t("SUBNETS")}
            customStyles={{width:'360px'}}
          />
        }
        <Divider/>
        <Toggle
          title={t("ADMIN_STATE_UP")}
          value={adminState}
          // customStyles={{marginTop:''}}
          onChange={() => setAdminState(!adminState)}
        />
        <div style={{display:"flex", gap:'6px', marginTop:'20px'}}>
          <Button
            variant="stroke"
            size="display"
            customStyles={{ width: '177px', justifyContent:'center' }}
            onClick={closeModalCancel}
            title={t("CANCEL")}
          />
          <Button
            variant="primary"
            size="display"
            customStyles={{ width: '177px', justifyContent:'center' }}
            onClick={handleSubmit}
            title={dataToEdit ? t("UPDATE") : t("CREATE")}
            loading={loading}
          />
        </div>
      </BodyModal>
    </Container>
  )
}

export default CreateRouter